import { combineReducers } from "@reduxjs/toolkit";
import { getAllCourseLevelReducer } from "./slices/getAllCourseLevel";

const courseLevelReducer = combineReducers({
  getAllCourseLevel: getAllCourseLevelReducer,
});

export default courseLevelReducer;
